import { render, staticRenderFns } from "./CtrlWorkingHours.vue?vue&type=template&id=45f80867&"
import script from "./CtrlWorkingHours.vue?vue&type=script&lang=js&"
export * from "./CtrlWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports